import { Colors } from '../Colors';
export const MenuBarOption = {
    titleIcon: {
        show: false,
        size: 30,
        color: Colors.pink,
        focus: Colors.p_blue,
    },
};
